module.exports = __webpack_public_path__ + "static/img/store_google.4cfe0edc.png";